import { dispatch } from "hf-rt";
import { HOST_URL } from "../constants";
import myBag from "./myBag";
import getCookie from "../function/getCookie";
import { loading } from "../models";

const initialState = {
  errorText: null,
  couponWarning: false,
  couponPopText: ""
};
const lang = getCookie("hk-emphasis-language");

export default {
  name: "coupon",
  actions: {
    postCouponCode: async function (code) {
      try {
        const data = [{ couponCode: code }];
        const response = await fetch(`${HOST_URL}/shopping/v1/coupons`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(data),
          credentials: "include"
        });
        if (response.ok) {
          // 再次取得myBag
          myBag.actions.fetchMyBag();
          // 清除錯誤提示文字
          this.couponErrorText(null);
          const data = await response.json();
          if (data.alertMessage) {
            this.showCouponWarning(true);
            this.getCouponPopText(data.alertMessage);
          }
        } else {
          const errortext =
            lang === "en"
              ? "Please enter a valid promotion code or voucher"
              : "請輸入有效的優惠券代碼或現金券";
          this.couponErrorText(errortext);
          throw new Error("POST_COUPON_FAIL");
        }
      } catch (error) {
        console.error(error);
      } finally {
      }
    },
    deleteCouponCode: async function (code) {
      loading.actions.startLoading(true);
      try {
        const response = await fetch(
          `${HOST_URL}/shopping/v1/coupons?couponCode=${code}`,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json"
            },
            credentials: "include"
          }
        );
        if (response.ok) {
          // 再次取得myBag
          myBag.actions.fetchMyBag();
          // 清除錯誤提示文字
          this.couponErrorText(null);
        } else {
          const errortext =
            lang === "en"
              ? "Deletion of promotional code is invalid"
              : "刪除優惠代碼無效";
          this.couponErrorText(errortext);
          throw new Error("DELETE_COUPON_FAIL");
        }
      } catch (error) {
        console.error(error);
        loading.actions.startLoading(false);
      } finally {
        
      }
    },
    couponErrorText: function (text) {
      dispatch({ type: "COUPON_ERROR_TEXT", text });
    },
    showCouponWarning: function (bool) {
      dispatch({ type: "SHOW_COUPON_WARNING", bool });
    },
    getCouponPopText: function (text) {
      dispatch({ type: "GET_COUPON_POP_TEXT", text });
    }
  },
  reducers: function (state = initialState, action) {
    switch (action.type) {
      case "COUPON_ERROR_TEXT":
        return {
          ...state,
          errorText: action.text
        };
      case "SHOW_COUPON_WARNING":
        return {
          ...state,
          couponWarning: action.bool
        };
      case "GET_COUPON_POP_TEXT":
        return {
          ...state,
          couponPopText: action.text
        };
      default:
        return state;
    }
  }
};
